// app/javascript/presentation/models/ContactGroupsModelMC.js
import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';

const resource = `${MERCATELY_API_V2}/contact_groups`;

const model = abstractModel(resource);

// Contact Groups - solo el método que estamos usando
model.getContactGroups = async (params = {}) =>
  model.get(params, { path: `${resource}/inbox_contact_groups` });

export default model;